import qs from 'query-string'

export function updateParamsInUrl(url, searchParams, hashParams) {
  const urlData = parseUrl(url)
  const searchString = searchParams ? qs.stringify(searchParams) : urlData.search.substring(1)
  const hashString = qs.stringify({ ...hashParamsOf(urlData.hash), ...hashParams })

  return [
    urlData.protocol,
    '//',
    urlData.hostname,
    urlData.port ? `:${urlData.port}` : '',
    urlData.pathname,
    searchString ? '?' : '',
    searchString,
    hashString ? '#' : '',
    hashString
  ].join('')
}

function hashParamsOf(hash) {
  if (!hash || hash.charAt(0) !== '#') return {}
  return parseParams(hash.slice(1))
}

function parseParams(str) {
  return str
    .split('&')
    .filter(pair => pair !== '')
    .map(pair => pair.split('='))
    .reduce((previousValue, pair) => {
      previousValue[pair[0]] = decodeURIComponent(pair[1] || '')
      return previousValue
    }, {})
}

function parseUrl(url) {
  const aEl = document.createElement('a')
  aEl.href = url
  const { protocol, hostname, port, pathname, search, hash, host } = aEl

  return {
    protocol,
    hostname,
    port: port && port !== '80' && port !== '443' ? port : '',
    pathname: pathname.startsWith('/') ? pathname : `/${pathname}`,
    search,
    hash,
    host
  }
}
